import axios from "utils/axios";

class AuthService {
  login(params) {
    return axios.post("login", params);
  }

  register(params) {
    return axios.post("register", params);
  }

  logout() {
    return axios.post("logout");
  }

  postPushNoticiationToken(token) {
    return axios.post("register-device-token", {
      device_id: "nullable",
      device_token: token,
      device_os_id: 3,
    });
  }

  verifyAccount(params) {
    return axios.post("verify-account", params);
  }

  forgotPassword(email) {
    return axios.post("forgot-password", {
      email,
    });
  }

  verifyResetPasswordToken(params) {
    return axios.post("verify-reset-token", params);
  }

  verifyEmail(params) {
    return axios.post("verify-email", params);
  }

  resendVerificationEmail(email) {
    return axios.post("resend-email-verification-code", {
      email,
    });
  }

  resetPassword(params, params2) {
    let data = {
      ...params,
      ...params2,
    };
    return axios.post("reset-password", data);
  }

  resendVerificationCode(email) {
    return axios.post("resend-verification-code", {
      email,
    });
  }
}

export default new AuthService();
